// Import Swiper and modules
import { Swiper, Navigation, Autoplay } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// Install modules
Swiper.use([Navigation, Autoplay]);

export function slider(selector, options) {
    return new Swiper(selector, options);
}